<script>
export default {
    props: [],
    data() {
        return {
            //
        }
    },
    methods: {
        setHeights() {
            let maxContainerHeight = 0;
            let maxButtonHeight = 0;
            for (var ref in this.$refs) {
                // if the width is bigger than height, let's use that to make it square
                let height = Math.max(jQuery(this.$refs[ref]).height(), jQuery(this.$refs[ref]).width());
                let buttonHeight = jQuery(this.$refs[ref]).find('.button').height();

                maxContainerHeight = Math.max(height, maxContainerHeight);
                maxButtonHeight = Math.max(buttonHeight, maxButtonHeight);
            }

            for (var ref in this.$refs) {
                jQuery(this.$refs[ref]).height(maxContainerHeight);
                jQuery(this.$refs[ref]).find('.button').height(maxButtonHeight);
            }
        }
    },
    computed: {
        //
    },
    mounted() {
        this.setHeights();

        screen.orientation.addEventListener('change', () => {
            this.setHeights()
        });
    },
}
</script>
